// RowActionsMenu.jsx
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";
const RowClientActionsMenu = ({
  row,
  onEdit,
  onDelete,
  onCreateSociety,
  onViewSocieties,
  hasPermission,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const isInactive = row.is_client_active == 0;
  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {!hasPermission("edit") && (
          <MenuItem
            onClick={() => {
              onEdit(row);
              handleClose();
            }}
          >
            Edit Client
          </MenuItem>
        )}
        {!hasPermission("delete") && (
          <MenuItem
            disabled={isInactive}
            onClick={() => {
              onDelete(row.client_id);
              handleClose();
            }}
          >
            Delete Client
          </MenuItem>
        )}
        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onCreateSociety(row.client_id, row.client_name, row.db_instance_id);
            handleClose();
          }}
        >
          Create Society
        </MenuItem>
        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onViewSocieties(row.client_id, row.client_name, row.db_instance_id);
            handleClose();
          }}
        >
          View Societies
        </MenuItem>
      </Menu>
    </>
  );
};
RowClientActionsMenu.propTypes = {
  row: PropTypes.shape({
    client_id: PropTypes.number.isRequired,
    client_name: PropTypes.string.isRequired,
    db_instance_id: PropTypes.number.isRequired,
    is_client_active: PropTypes.number.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onCreateSociety: PropTypes.func.isRequired,
  onViewSocieties: PropTypes.func.isRequired,
  hasPermission: PropTypes.func.isRequired,
};
export default RowClientActionsMenu;
